import { FC } from 'react'
import { LanguageHelp } from '../../../helpers/LanguageHelper'
import { GeoLanguageCountryOption, withAllLanguageOption } from '../../../helpers/GeoLanguageHelper'
import { GeoLanguageCountrySelect } from './GeoLanguageCountrySelect'

type Props = {
  className?: string
  functionSubmit?: (data: string, type: string) => void
  options?: GeoLanguageCountryOption[]
  selectedKey: string
}

const DropdownFilterLanguage: FC<Props> = ({
  className = '',
  functionSubmit,
  options = [],
  selectedKey = '',
}) => {
  return (
    <GeoLanguageCountrySelect
      className={className}
      options={withAllLanguageOption(options)}
      selectedKey={selectedKey}
      allLabel={LanguageHelp('All Languages')}
      placeholder={LanguageHelp('Search language')}
      onChange={(key) => functionSubmit?.(key, 'language')}
    />
  )
}

export { DropdownFilterLanguage }
